import { CHANGE_NAME_OR_CAREER } from '../actions/changeNameOrCareerActions';

const initialState = 1;

const changeNameOrCareerReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_NAME_OR_CAREER:
            return action.payload.value
        default:
            return state;
    }
}

export default changeNameOrCareerReducer;